import { Button, Card, Form, Modal, Select, Table } from 'antd';
import React, { useState } from 'react';

import { UploadImage } from '@/components/UI/UploadImage';
import type { UploadImageDataType } from '@/components/UI/UploadImage/types';

import { CARD_BODY_STYLES, CARD_HEAD_STYLES } from '../../constants';
import { DUMMY_SERVICE_POINTS_TABLE_DATASOURCE } from './constants';
import { getServicePointsTableColumns } from './helpers';
import styles from './index.module.scss';
import type { ServicePointsTableData } from './types';

export const ServicePointsTable = () => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingData, setEditingData] = useState<
    ServicePointsTableData | undefined
  >(undefined);
  const [uploadImage, setUploadImage] = useState<
    UploadImageDataType | undefined
  >(undefined);

  const handleEditButtonClick = (record: ServicePointsTableData) => {
    setEditingData(record);
    setShowEditModal(true);
  };

  const tableColumns = getServicePointsTableColumns(handleEditButtonClick);

  const closeModal = () => {
    setUploadImage(undefined);
    setShowEditModal(false);
  };

  const handleModalOk = () => {
    // TODO: 邏輯待寫
    console.log('Update!');
    closeModal();
  };

  const onEditFormFinish = (formValues: { isActive: boolean }) => {
    // TODO: 邏輯待寫
    console.log({ ...formValues, imageFile: uploadImage?.imageFile });
    closeModal();
  };

  // TODO: 正式串接API後，記得刪除這個log
  console.log(editingData);

  return (
    <>
      <Card
        title="點數功能管理"
        headStyle={CARD_HEAD_STYLES}
        bodyStyle={CARD_BODY_STYLES}
      >
        <Table
          bordered
          rowKey="serviceName" // TODO: 到時候看rowKey需不需要改
          scroll={{ x: 'max-content' }}
          columns={tableColumns}
          dataSource={DUMMY_SERVICE_POINTS_TABLE_DATASOURCE}
        />
      </Card>
      <Modal
        open={showEditModal}
        centered
        destroyOnClose
        onCancel={closeModal}
        onOk={handleModalOk}
        footer={null}
      >
        <Form
          initialValues={{ isActive: !!editingData?.isActive }}
          onFinish={onEditFormFinish}
          layout="vertical"
        >
          <div className={styles.formTitle}>
            <p>服務</p>
            <p>{editingData?.serviceName}</p>
          </div>
          <Form.Item
            label="點數功能開/關"
            name="isActive"
            rules={[{ required: true }]}
          >
            <Select
              options={[
                { label: '開', value: true },
                { label: '關', value: false },
              ]}
            />
          </Form.Item>
          <Form.Item label="上傳圖片">
            <UploadImage
              imageUrl={
                editingData?.imageUrl || uploadImage?.previewUrl || undefined
              }
              onImageChange={setUploadImage}
            />
          </Form.Item>
          <Form.Item className={styles.submitButton}>
            <Button htmlType="submit">確認</Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
